"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeCache = void 0;
function makeCache(items, key, start) {
    return items === null || items === void 0 ? void 0 : items.reduce((cur, item) => {
        cur[item[key]] = item;
        return cur;
    }, Object.assign({}, start));
}
exports.makeCache = makeCache;
//# sourceMappingURL=ReduxUtil.js.map